import { getTvObject } from '@costar-ui/cosmos';
import radiusOptions from '../radius-options/radius-options.esm.js';
import spacingOptions from '../space-options/spacing-options.esm.js';
import surfaceOptions from '../surface-options/surface-options.esm.js';

var popoverOptions = getTvObject({
  base: ['relative', 'flex', 'border', 'border-neutral', 'data-[trigger=Dropdown]:rounded-sm', 'data-[trigger=Dropdown]:border-focus', 'shadow-elevation-20'],
  variants: {
    color: surfaceOptions.color,
    radius: radiusOptions.radius,
    padding: spacingOptions.padding,
    margin: spacingOptions.margin,
    marginY: spacingOptions.marginY,
    isEntering: {
      "true": ['duration-200', 'ease-out', 'animate-in', 'fade-in', 'placement-left:slide-in-from-right-1', 'placement-right:slide-in-from-left-1', 'placement-top:slide-in-from-bottom-1', 'placement-bottom:slide-in-from-top-1']
    },
    isExiting: {
      "true": ['duration-150', 'ease-in', 'animate-out', 'fade-out', 'placement-left:slide-out-to-right-1', 'placement-right:slide-out-to-left-1', 'placement-top:slide-out-to-bottom-1', 'placement-bottom:slide-out-to-top-1']
    }
  }
});
var popoverOptions$1 = popoverOptions;

export { popoverOptions$1 as default };
//# sourceMappingURL=popover-options.esm.js.map
